@if (isLoading) {
  <wpro-spinner-default></wpro-spinner-default>
}
@if (!isMock) {
  <iframe #iframe title="Two Factor"></iframe>
}
@if (!(isMock || isMockWindow)) {
  <iframe #twoFactorControl title="Two Factor" class="two-factor-control"></iframe>
} @else {
  <div #twoFactorControl class="two-factor-control mock-control">
    <h2>Mock Two Factor Authentication</h2>
    <button class="success" (click)="__onClick('success')">ACCEPT</button>
    <button class="danger" (click)="__onClick('fail')">REJECT</button>
  </div>
}

